import type { BreadcrumbLevels } from '@/utils/breadcrumb'
import { VpHomeIcon } from '@vtmn-play/icons/react'
import { VpBreadcrumbs, VpBreadcrumbsItem, VpSkeleton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { Link, useMatch } from 'react-router'
import './breadcrumb.scss'

export interface BreadcrumbProps {
  levels: BreadcrumbLevels
}

export function Breadcrumb({ levels }: Readonly<BreadcrumbProps>) {
  const { t } = useTranslation()
  const exactSeasonMatch = useMatch('/:season')
  const deepSeasonMatch = useMatch('/:season/*')
  const currentSeason = (deepSeasonMatch ?? exactSeasonMatch)?.params?.season ?? ''

  const getUrl = (index: number) =>
    levels
      .slice(0, index + 1)
      .reduce(
        (acc, curr) => `${acc}/${curr.level}/${curr.id}`,
        `/${currentSeason}`,
      )

  return (
    <VpBreadcrumbs
      data-testid="breadcrumb"
      aria-label={t('aria-label.breadcrumb')}
    >
      <VpBreadcrumbsItem asChild>
        <Link
          to="/"
          className="breadcrumb-home-link"
          style={{ display: 'flex', gap: 'var(--vp-semantic-spacing-2xs)', alignItems: 'center' }}
        >
          <VpHomeIcon size={16} aria-hidden="true" />
          <span>{t('homepage')}</span>
        </Link>
      </VpBreadcrumbsItem>
      <VpBreadcrumbsItem asChild>
        <Link to={`/${currentSeason}`}>
          {t('universes')}
        </Link>
      </VpBreadcrumbsItem>
      {levels.map((item, index) => (
        <VpBreadcrumbsItem
          key={`${item.level}-${item.id}`}
          asChild
          data-testid={`breadcrumb-item-${item.level}`}
        >
          {!Number(item.label)
            ? (
                <Link to={getUrl(index)}>
                  {item.label}
                </Link>
              )
            : <VpSkeleton shape="squared" style={{ width: '144px', height: '22px' }} />}
        </VpBreadcrumbsItem>
      ))}
    </VpBreadcrumbs>
  )
}
